<template>
  <div>
    <v-dialog v-model="dialog" max-width="900" style="overflow: hidden !important;">
      <v-card>
        <v-card-title> {{processType === "new" ? "Yeni Ziyaret Ekle" : "Ziyareti Düzenle"}}
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog()" color="danger darken-1" style="color:white">
            KAPAT
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <v-textarea solo dense filled v-model="visitForm.description" placeholder="Açıklama"
                              @input="$v.visitForm.description.$touch()" @blur="$v.visitForm.description.$touch()"
                              :error-messages=" validationMessages($v.visitForm.description, 'Açıklama') "></v-textarea>
              </div>
              <div class="col-lg-12">
                <v-text-field solo dense filled v-model="visitForm.authorizedName" placeholder="Yetkili Kişi"
                              @input="$v.visitForm.authorizedName.$touch()" @blur="$v.visitForm.authorizedName.$touch()"
                              :error-messages=" validationMessages($v.visitForm.authorizedName, 'Yetkili Kişi') "></v-text-field>
              </div>
              <div class="col-lg-4">
                <v-menu transition="scale-transition" offset-y :close-on-content-click="false" min-width="auto">
                  <template v-slot:activator="{on,attrs}">
                    <v-text-field
                        @input="$v.visitForm.visitDate.$touch()"
                        @blur="$v.visitForm.visitDate.$touch()"
                        :error-messages="
                  validationMessages($v.visitForm.visitDate, 'Başlangıç tarihi')
                "
                        :value="formattedDate(visitForm.visitDate)"
                        label="Ziyaret Tarihi"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        filled
                        solo
                        placeholder=" "
                        clearable
                        @click:clear="visitForm.visitDate = null"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="visitForm.visitDate"
                      locale="tr"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="col-lg-4">
                <v-menu ref="menuStartTime" transition="scale-transition" offset-y :close-on-content-click="false" min-width="auto">
                  <template v-slot:activator="{on,attrs}">
                    <v-text-field
                        @input="$v.visitForm.startTime.$touch()"
                        @blur="$v.visitForm.startTime.$touch()"
                        :error-messages="
                  validationMessages($v.visitForm.startTime, 'Ziyaret Başlangıç Saati')
                "
                        :value="visitForm.startTime"
                        label="Ziyaret Başlangıç Saati"
                        prepend-inner-icon="mdi-clock"
                        readonly
                        dense
                        filled
                        solo
                        placeholder=" "
                        clearable
                        @click:clear="visitForm.startTime = null"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                      v-model="visitForm.startTime"
                      format="24hr"
                  >
<!--                    <template #default>-->
<!--                      <v-btn color="success darken-1" @click="closeStartTimeMenu">Ayarla</v-btn>-->
<!--                    </template>-->
                  </v-time-picker>
                </v-menu>
              </div>
              <div class="col-lg-4">
                <v-menu ref="menuEndTime" transition="scale-transition" offset-y :close-on-content-click="false" min-width="auto">
                  <template v-slot:activator="{on,attrs}">
                    <v-text-field
                        @input="$v.visitForm.endTime.$touch()"
                        @blur="$v.visitForm.endTime.$touch()"
                        :error-messages="
                  validationMessages($v.visitForm.endTime, 'Ziyaret Bitiş Saati')
                "
                        :value="visitForm.endTime"
                        label="Ziyaret Bitiş Saati"
                        prepend-inner-icon="mdi-clock"
                        readonly
                        dense
                        filled
                        solo
                        placeholder=" "
                        clearable
                        @click:clear="visitForm.endTime = null"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                      v-model="visitForm.endTime"
                      format="24hr"
                  >
<!--                    <template #default>-->
<!--                      <div>-->
<!--                      <v-btn color="success darken-1" @click="closeEndTimeMenu">Ayarla</v-btn>-->
<!--                      </div>-->
<!--                    </template>-->
                  </v-time-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn small class="me-1" color="secondary" @click="closeDialog()">İptal Et</v-btn>
            <v-btn small color="success" @click="saveVisit">Kaydet</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages";
import {formattedDate} from "@/momentHelper";
import {mapActions, mapState} from "vuex";
import {required} from "vuelidate/lib/validators";

export default {
  name: "NewVisitDialog",
  mixins: [validationMixin],
  validations() {
    return{
      visitForm: {
        description: {required},
        authorizedName: {required},
        visitDate: {required}
      }
    }
},
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    processType: {
      type: String,
      default: "new"
    },
    visitId: {
      type: Number,
      default: null,
    },
    visitProp: {
      type: Object,
      default: () => ({
        id: null,
        salesPersonCode: null,
        salesPersonName: null,
        currentCode: null,
        currentName: null,
        description: null,
        visitDate: null,
        authorizedName: null,
        startTime: null,
        endTime: null
      }),
    }
  },
  data() {
    return {
      visitForm: {
        id: null,
        salesPersonCode: null,
        salesPersonName: null,
        currentCode: null,
        currentName: null,
        description: null,
        visitDate: null,
        authorizedName: null,
        startTime: null,
        endTime: null,
        isClosed: null,
      },
      dialog: false,
    }
  },
  computed: {
    ...mapState("auth",["user"]),
    ...mapState("visit", ["selectedCurrentCode","selectedCurrentName"]),
    formattedVisitStartTime() {
      const startTimeDate = new Date();
      const [hours, minutes] = this.visitForm.startTime.split(":");
      startTimeDate.setHours(parseInt(hours, 10));
      startTimeDate.setMinutes(parseInt(minutes, 10));
      startTimeDate.setSeconds(0);
      return startTimeDate.getTime();
    },
    formattedVisitEndTime() {
      const endTimeDate = new Date();
      const [hours, minutes] = this.visitForm.endTime.split(":");
      endTimeDate.setHours(parseInt(hours, 10));
      endTimeDate.setMinutes(parseInt(minutes, 10));
      endTimeDate.setSeconds(0);
      return endTimeDate.getTime();
    },
  },
  methods: {
    formattedDate,
    validationMessages,
    ...mapActions("visit", ["currentVisitAdd", "currentVisitUpdate", "fetchCurrentVisitList"]),
    async _currentVisitAdd() {
      await this.currentVisitAdd({
        params: {
          userId: this.user.UserId,
        },
        body: {
          visitDate: this.visitForm.visitDate,
          startTime: this.visitForm.startTime,
          endTime: this.visitForm.endTime,
          currentCode: this.selectedCurrentCode,
          currentName: this.selectedCurrentName,
          salesPersonCode: this.user.SalesPersonCode,
          salesPersonName: this.user.FullName,
          authorizedName: this.visitForm.authorizedName,
          description: this.visitForm.description,
        }
      })
    },
    async _currentVisitUpdate() {
      await this.currentVisitUpdate({
        params: {
          userId: this.user.UserId
        },
        body: {
          id: this.visitProp.id,
          visitDate: this.visitProp.visitDate,
          startTime: this.visitForm.startTime,
          endTime: this.visitForm.endTime,
          currentCode: this.selectedCurrentCode,
          currentName: this.selectedCurrentName,
          salesPersonCode: this.user.SalesPersonCode,
          salesPersonName: this.user.FullName,
          authorizedName: this.visitForm.authorizedName,
          description: this.visitForm.description,
          isClosed: this.visitForm.isClosed,
        },
        urlSegments: [],
      });
    },
    closeDialog() {
      this.dialog = false;
      this.$v.$reset();
    },
    async saveVisit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.processType === "new") {
          await this._currentVisitAdd();
          await this.$parent._fetchCurrentVisitList();
          this.dialog = false;
        } else {
          await this._currentVisitUpdate();
          await this.fetchCurrentVisitList({
            params: {
              userId: this.user.UserId,
              currentCode: this.selectedCurrentCode
            },
            body: {}
          });
          this.dialog = false;
        }
      }
      this.visitForm = {
        id: null,
        salesPersonCode: null,
        salesPersonName: null,
        currentCode: null,
        currentName: null,
        description: null,
        visitDate: null,
        authorizedName: null,
        startTime: null,
        endTime: null,
        isClosed: null,
      }
      this.closeDialog();
    },
    closeStartTimeMenu() {
      this.$refs.menuStartTime.isActive = false;
    },
    closeEndTimeMenu() {
      this.$refs.menuEndTime.isActive = false;
    },
  },
  watch: {
    dialog: function(newVal) {
      this.$emit("dialogChange", newVal);
    },
    showDialog: function(newVal) {
      this.dialog = newVal;
    },
    visitProp: function(newVal) {
      this.visitForm = Object.assign({},newVal);
    }
  }
}
</script>

<style scoped>
</style>